import Form from '../../kingpin/forms/Form';
import FormHeader from '../../kingpin/forms/FormHeader';
import FormContent from '../../kingpin/forms/FormContent';
import Card from '../Common/Card';
import Typography from '../../kingpin/atoms/Typography';
import toSentenceCase from '../../services/toSentenceCase';
import styled from 'styled-components';
import { useContext, useMemo } from 'react';
import { GroupVsRemainderContext } from './GroupVsRemainderProvider';
import Tooltip from '../Tooltip';

const PeerGroupContainer = styled.div`
  background-color: rgb(251, 251, 254);
  border: 1px solid rgb(233, 233, 233);
  border-radius: 4px;
  display: inline-flex;
  flex-direction: row;
  -webkit-box-align: center;
  align-items: center;
`;

const PeerGroupSection = styled.div`
  border-right: 1px solid rgb(233, 233, 233);
  padding: 4px 12px;
  font-size: 12px;
`;

const PeerGroupInfoPopup = ({
  close,
  gadget,
}: {
  close: () => void;
  gadget: VisualisationDefinitions.GroupVsRemainder;
}) => {
  const { peerGroupValues } = useContext(GroupVsRemainderContext);

  const peerGroup: {
    operator: string;
    displayValue: string;
    tooltipValues?: string;
  } | null = useMemo(() => {
    if (peerGroupValues && peerGroupValues?.length === 1) {
      return {
        operator: 'is',
        displayValue: peerGroupValues[0].toString(),
      };
    } else if (peerGroupValues && peerGroupValues?.length > 1) {
      return {
        operator: 'is one of',
        displayValue: `${peerGroupValues.length} ${gadget.peerGroup}s`,
        tooltipValues: peerGroupValues.join(', '),
      };
    }
    return null;
  }, [gadget.peerGroup, peerGroupValues]);

  return (
    <Form>
      <FormHeader title={'Gadget Details'} onClose={close} />
      <FormContent style={{ padding: 15 }}>
        <Card style={{ padding: 16, marginBottom: 20 }}>
          <div style={{ display: 'flex', gap: 5, marginBottom: 16 }}>
            <Typography.Body type={'Body 13 Bold'}>Dataset: </Typography.Body>
            <Typography.Body type={'Body 13'}>
              {toSentenceCase(gadget.dataset)}
            </Typography.Body>
          </div>
          {gadget.description && (
            <div style={{ display: 'flex', gap: 5 }}>
              <Typography.Body type={'Body 13 Bold'}>
                Description:{' '}
              </Typography.Body>
              <Typography.Body type={'Body 13'}>
                {gadget.description}
              </Typography.Body>
            </div>
          )}
          <div style={{ display: 'flex', gap: 5 }}>
            <Typography.Body type={'Body 13 Bold'}>Field: </Typography.Body>
            <Typography.Body type={'Body 13'}>
              {toSentenceCase(gadget.field)}
            </Typography.Body>
          </div>
          {peerGroup && (
            <div style={{ marginTop: 16 }}>
              <Typography.Header type={'H3'}>Peer Group</Typography.Header>
              <div style={{ display: 'flex', gap: 5 }}>
                <PeerGroupContainer>
                  <PeerGroupSection>{gadget.peerGroup}</PeerGroupSection>
                  <PeerGroupSection>{peerGroup.operator}</PeerGroupSection>
                  <Tooltip content={peerGroup.tooltipValues}>
                    <PeerGroupSection>
                      {peerGroup.displayValue}
                    </PeerGroupSection>
                  </Tooltip>
                </PeerGroupContainer>
              </div>
            </div>
          )}
        </Card>
      </FormContent>
    </Form>
  );
};

export default PeerGroupInfoPopup;
